import { useEffect, useMemo } from 'react';
import { useParams } from 'react-router-dom';
import { DIAGNOSTICS_DATE_FORMAT } from '@/const';
import { format } from 'date-fns';
import { getAssetById } from '@/store/queries';
import { useLazyGetDiagnosticsQuery } from '@/store/api/diagnosticApi';

export const useFetchDiagnostics = (fromDate: Date, toDate: Date) => {
  const [fetchDiagnostics, { data, isLoading, isFetching }] = useLazyGetDiagnosticsQuery();
  const { siteId, id } = useParams();
  const { asset } = getAssetById(siteId, id);

  const getDiagnostics = () => {
    const fromDateISO = format(fromDate, DIAGNOSTICS_DATE_FORMAT);
    const toDateISO = format(toDate, DIAGNOSTICS_DATE_FORMAT);
    if (siteId) {
      fetchDiagnostics(
        {
          site_id: siteId,
          assets_ids: id,
          from_date: fromDateISO,
          to_date: toDateISO,
          asset_category: asset?.asset_category || 'fixed',
        },
        true
      ).unwrap();
      // .catch((e) => {
      //   Sentry.captureException(e);
      //   toast({
      //     status: TOAST_STATUS.Error,
      //     title: `Failed to load information for machine: ${asset?.asset_ui_name}`,
      //     description: t('general.errors.communication'),
      //   });
      // });
    }
  };

  const components = useMemo(() => {
    return (
      data &&
      Object.values(data)
        .flatMap((entry: any) => entry[1].assets)
        .flatMap((el) => el.components)
        .filter(
          (component, index, self) => index === self.findIndex((a) => a?.component_id === component?.component_id)
        )
    );
  }, [data]);

  // Use only asset_category as dependency (not the whole asset object which may be unstable reference)
  const assetCategory = asset?.asset_category;
  useEffect(() => {
    getDiagnostics();
  }, [siteId, id, assetCategory]);

  return { isLoading, isFetching, diagnostics: data, components, asset, assetId: id, getDiagnostics };
};
